import React, { Component } from 'react';
import { Link } from 'react-router-dom'

import "./Header-MenuItem.scss"

class MenuItem extends Component {
    constructor() {
        super();
        this.state = {
            clicked: 1
        }
    }
    clickedMenuItem(item) {
        window.dataLayer.push({
            'event': 'GA_Event',
            'Category': 'Isracard',
            'Action': 'Navigation',
            'Label': item.name.replace(/<(?:.|\n)*?>/gm, '')
        });

        if(this.state.clicked === 1)    {
            //window.document.getElementById("menu").classList.remove("active");
            window.document.querySelector(".appmenu").classList.remove("active");
            this.setState({
                clicked: 0
            })
        } else{
            this.setState({
                clicked: 1
            })
        }
        this.props.closeMenu();
        this.props.scrollFromMenu(item.scrollTo);
    }
    render() {
        return (
            <li>
                <Link to={this.props.item.link} onClick={(link) => this.clickedMenuItem(this.props.item)}>
                    <div className="box" dangerouslySetInnerHTML={{ __html: this.props.item.name }}></div>
                </Link>
            </li>
        )
    }
}

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/Header/components/Header-MenuItem/Header-MenuItem.js